import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { INCIDENTS_ENABLED, INCIDENTS_NAMESPACE } from "src/lib/config.helper";
import { type IncidentDto } from "src/types/incidentDto";

import { apiGetIncidents } from "./incidents.api";

function isActiveIncident(item: IncidentDto): boolean {
  return new Date(item.endTS).getTime() > Date.now();
}

export const useIncidentsQuery = (): UseQueryResult<IncidentDto[], Error> =>
  useQuery<IncidentDto[], Error>({
    queryKey: ["incidents"],
    queryFn: () => apiGetIncidents(),
    enabled: INCIDENTS_ENABLED,
    staleTime: Number.POSITIVE_INFINITY,
    select: (data) => data.filter((item) => isActiveIncident(item) && item.namespace.includes(INCIDENTS_NAMESPACE)),
  });
